/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var LabelShiftType = /*@__PURE__*/ (function (LabelShiftType) {
    LabelShiftType[LabelShiftType["Line"] = 0] = "Line";
    LabelShiftType[LabelShiftType["Box"] = 1] = "Box";
    LabelShiftType[LabelShiftType["Border"] = 2] = "Border";
    return LabelShiftType;
})({});
/**
 * @hidden
 */
export var LabelShiftType_$type = /*@__PURE__*/ markEnum('LabelShiftType', 'Line,0|Box,1|Border,2');
//# sourceMappingURL=LabelShiftType.js.map
